import { IconProps } from '../types';

export const InfoIcon = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#768EA7"
      d="M8 7.333c.369 0 .667.298.667.666v2.667a.667.667 0 1 1-1.333 0V7.999c0-.368.298-.666.666-.666ZM8 4.666a.667.667 0 1 0 0 1.333h.007a.667.667 0 0 0 0-1.333H8Z"
    />
    <path
      fill="#768EA7"
      fillRule="evenodd"
      d="M.667 8a7.333 7.333 0 1 1 14.667 0A7.333 7.333 0 0 1 .667 8ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
      clipRule="evenodd"
    />
  </svg>
);
